export function mapAnswerToNode(item) {
    return {
        id: item.id,
        data: item.data,
        type: item.type,
        ctime: item.ctime,
        utime: item.utime,
    };
}
